// src/utils/loadGoogleMaps.js
let _loadPromise = null;

export function loadGoogleMaps(apiKey, libraries = []) {
  // Already fully ready — resolve immediately
  if (
    window.google &&
    window.google.maps &&
    typeof window.google.maps.Map === "function"
  ) {
    return Promise.resolve(window.google);
  }

  // Already in progress — reuse same promise
  if (_loadPromise) return _loadPromise;

  _loadPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    const librariesParam =
      libraries.length > 0 ? `&libraries=${libraries.join(",")}` : "";

    // ── Removed &loading=async — that's what breaks first-load timing ──
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;

    script.onload = () => {
      // Poll until window.google.maps.Map is truly a constructor
      let attempts = 0;
      const poll = () => {
        if (
          window.google &&
          window.google.maps &&
          typeof window.google.maps.Map === "function"
        ) {
          resolve(window.google);
        } else if (attempts++ > 30) {
          _loadPromise = null;
          reject(new Error("Google Maps initialized but Map constructor never appeared"));
        } else {
          setTimeout(poll, 100);
        }
      };
      poll();
    };

    script.onerror = (e) => {
      _loadPromise = null;
      reject(new Error("Google Maps script failed to load: " + e));
    };

    document.head.appendChild(script);
  });

  return _loadPromise;
}